import { ComponentRegistry } from '@enonic/react-components';
import { Frontpage } from '/react4xp/components/parts/frontpage/Frontpage';
import { Page } from '/react4xp/components/Page/Page';
import { Subpage } from '/react4xp/components/parts/subpage/Subpage';

export const componentRegistry = new ComponentRegistry();

componentRegistry.addContentType('portal:site', { View: Frontpage });
componentRegistry.addPage('no.brreg.jobb:Page', { View: Page });
componentRegistry.addContentType('no.brreg.jobb:subpage', { View: Subpage });
